import className from "classnames";
import {
  GOVGR_CARD,
  GOVGR_CARD__BODY,
  GOVGR_CARD__BORDER,
  GOVGR_CARD__BORDER_GRAY,
} from "../../conf/styles/GovGrCard";

const GovGrCard = (props) => {
  let CardWrapperClass = className(
    GOVGR_CARD,
    GOVGR_CARD__BORDER,
    GOVGR_CARD__BORDER_GRAY
  );
  let BodyWrapperClass = className(GOVGR_CARD__BODY);
  return (
    <div className={CardWrapperClass}>
      <div className={BodyWrapperClass}>{props.children}</div>
    </div>
  );
};
export default GovGrCard;
